export const UPGRADE_REQUEST_SOURCES = {
	COLLABORATOR_GROUPS: 'collaboratorGroups',
	ASSIGN_ASSETS: 'assignAssets',
	MANAGER_REVIEWER_ROLE: 'managerReviewerRole',
	PUBLIC_LINK_SHARING: 'publicLinkSharing',
	VERSION_HISTORY: 'versionHistory',
	OVERVIEW: 'overview'
} as const;

export type UpgradeRequestSource = typeof UPGRADE_REQUEST_SOURCES[keyof typeof UPGRADE_REQUEST_SOURCES];
